module.exports = __webpack_public_path__ + "img/HIW-COVER.2145c337.png";